import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import moment from 'moment';
import { prettifyAdObjective } from '../../helpers/adTypeFromPost';
import { PostListContent, SocialNetworkIconBar } from 'components';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
var Wrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  border: 0;\n  justify-content: space-between;\n  align-content: center;\n  overflow: hidden;\n  min-height: 28px;\n"])));
var PostWrap = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var Time = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border-left: 1px solid #dddddd;\n  flex: 0 0 95px;\n  max-width: 95px;\n  padding: 15px 10px;\n"])));
var Date = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex: 0 0 135px;\n  max-width: 135px;\n  padding: 15px 10px;\n"])));
var FilterTypeWrap = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex: 0 0 160px;\n  font-size: 13px;\n  margin-right: 36px;\n  padding-bottom: 12px;\n"])));
var FilterTypeCircle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: rgb(", ");\n  border-radius: 50%;\n  display: inline;\n  float: left;\n  height: 18px;\n  margin-right: 8px;\n  width: 18px;\n"])), function (props) {
  return props.bgColor;
});

function AgendaEvent(props) {
  var _event$post, _event$post$adDetails, _event$post$adDetails2, _event$post2;

  var deletingPost = props.deletingPost,
      deleteLivePost = props.deleteLivePost,
      event = props.event,
      handleDelete = props.handleDelete,
      handleEdit = props.handleEdit,
      handleReuse = props.handleReuse,
      organization = props.organization,
      parsedLinks = props.parsedLinks,
      parseLink = props.parseLink;
  var imageUrl = event.post.S3Files && event.post.S3Files.length && event.post.S3Files[0].fullyQualifiedUrl ? [event.post.S3Files[0].fullyQualifiedUrl] : event.post.type === 'AD' && event !== null && event !== void 0 && (_event$post = event.post) !== null && _event$post !== void 0 && (_event$post$adDetails = _event$post.adDetails) !== null && _event$post$adDetails !== void 0 && (_event$post$adDetails2 = _event$post$adDetails.creative) !== null && _event$post$adDetails2 !== void 0 && _event$post$adDetails2.thumbnail_url ? event.post.adDetails.creative.thumbnail_url : null;
  var postType = 'textPost';

  if (event.post.linkUrl) {
    postType = 'linkPost';
  } else if (imageUrl) {
    postType = 'imagePost';
  } else if (event.post.videoUrl) {
    postType = 'videoPost';
  }

  if (postType === 'linkPost') {
    if (parsedLinks[event.post.linkUrl]) {
      event.post.linkData = parsedLinks[event.post.linkUrl];
    } else {
      parseLink(event.post.linkUrl);
    }
  }

  var belowMessageContent = postType === 'linkPost' ? /*#__PURE__*/React.createElement("a", {
    href: event.post.linkUrl,
    style: {
      color: '#1f5180',
      textDecoration: 'none',
      fontSize: 13
    },
    target: "_blank"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-link",
    style: {
      marginRight: 6
    }
  }), "Link Post") : postType === 'videoPost' ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13
    }
  }, "Video Post") : null;
  var message = event.post.message ? event.post.message : postType === 'linkPost' && event.post.linkData ? event.post.linkData.parsing ? 'Loading...' : event.post.linkData.description : 'No message';
  var image = imageUrl;

  if (postType === 'linkPost' && !imageUrl) {
    if (event.post.linkData && !event.post.linkData.parsing && event.post.linkData.imageUrl) {
      image = event.post.linkData.imageUrl;
    }
  }

  var videoUrl = event.post.videoUrl;
  var bgColor;
  var filterName;

  switch (event.itemFilterType) {
    case 'CANVAS_APP_INSTALLS_AD':
    case 'CANVAS_APP_ENGAGEMENT_AD':
    case 'EVENT_RESPONSES_AD':
    case 'LINK_CLICKS_AD':
    case 'OFFER_CLAIMS_AD':
    case 'PAGE_LIKES_AD':
    case 'MOBILE_APP_INSTALLS_AD':
    case 'MOBILE_APP_ENGAGEMENT_AD':
    case 'PRODUCT_CATALOG_SALES_AD':
    case 'VIDEO_VIEWS_AD':
    case 'LEAD_GENERATION_AD':
    case 'LOCAL_AWARENESS_AD':
    case 'BRAND_AWARENESS_AD':
    case 'REACH_AD':
    case 'APP_INSTALLS_AD':
    case 'CONVERSIONS_AD':
      bgColor = '189,153,219';
      filterName = prettifyAdObjective(event.itemFilterType);
      break;

    case 'POST_ENGAGEMENT_AD':
      bgColor = '186,159,134';
      filterName = 'Boosted Post';
      break;

    case 'CUSTOM_CONTENT':
      bgColor = '244,184,87';
      filterName = 'Custom Content';
      break;

    case 'GROUP_POST':
      bgColor = '65,198,174';
      filterName = 'Group Post';
      break;

    case 'COMPOSED_CONTENT':
      bgColor = '184,209,235';
      filterName = 'Composed Content';
      break;

    case 'SUBSCRIBED_CONTENT':
      bgColor = '185,94,94';
      filterName = 'Subscribed Content';
      break;

    default:
      bgColor = '245,166,35';
      filterName = 'Other';
  }

  var createActionButtons = function createActionButtons(post) {
    var pastPost = moment(post.publishAt).isBefore(moment());
    var actions = [];

    if (post.type === 'AD') {
      return false;
    } else if (pastPost) {
      var _post$PostResult;

      actions = [post !== null && post !== void 0 && (_post$PostResult = post.PostResult) !== null && _post$PostResult !== void 0 && _post$PostResult.results && post.PostResult.results.length > 0 ? /*#__PURE__*/React.createElement(FlatButton, null, /*#__PURE__*/React.createElement(MenuItem, {
        innerDivStyle: {
          alignItems: 'center',
          display: 'flex',
          height: 32
        },
        style: {
          minHeight: 32,
          width: 112
        },
        primaryText: /*#__PURE__*/React.createElement("span", {
          style: {
            fontFamily: 'Open Sans',
            fontWeight: 300,
            textTransform: 'uppercase',
            fontSize: 13,
            color: 'rgb(97,97,97)'
          }
        }, "View Post"),
        rightIcon: /*#__PURE__*/React.createElement(ArrowDropRight, {
          style: {
            height: 32,
            margin: 0
          }
        }),
        menuItems: post.PostResult.results.filter(function (r) {
          return r.account.platform !== 'Instagram';
        }).map(function (_ref) {
          var account = _ref.account,
              response = _ref.response;
          return /*#__PURE__*/React.createElement(MenuItem, {
            primaryText: account.platform,
            onClick: function onClick() {
              if (response.error && "".concat(response.state) !== '1') {
                return alert("This post was unable to be submitted. (Error: ".concat(response.error, ")"));
              }

              if (response.url.includes('twitter.com')) {
                var sa = function () {
                  var sap = post.SocialAccountPosts.find(function (s) {
                    return s.SocialAccount.platformId === account.platform_id;
                  });
                  return sap ? sap.SocialAccount : null;
                }();

                if (sa) {
                  var id = "".concat(response.url).split('/').pop();
                  window.open("https://twitter.com/".concat(sa.username, "/status/").concat(id), '_blank');
                }
              } else {
                window.open(response.url, '_blank');
              }
            }
          });
        })
      })) : null, post.PostResult && post.PostResult.results && post.PostResult.results.length > 0 && post.PostResult.results.filter(function (r) {
        return ['Facebook page', 'Twitter'].includes(r.account.platform);
      }).length > 0 ? /*#__PURE__*/React.createElement(FlatButton, {
        style: {
          marginLeft: 24
        }
      }, /*#__PURE__*/React.createElement(MenuItem, {
        innerDivStyle: {
          alignItems: 'center',
          display: 'flex',
          height: 32
        },
        style: {
          minHeight: 32,
          width: 126
        },
        primaryText: /*#__PURE__*/React.createElement("span", {
          style: {
            fontFamily: 'Open Sans',
            fontWeight: 300,
            textTransform: 'uppercase',
            fontSize: 13,
            color: 'rgb(97,97,97)'
          }
        }, "Delete Post"),
        rightIcon: /*#__PURE__*/React.createElement(ArrowDropRight, {
          style: {
            height: 32,
            margin: 0
          }
        }),
        menuItems: post.PostResult.results.filter(function (r) {
          return ['Facebook page', 'Twitter'].includes(r.account.platform);
        }).map(function (_ref2) {
          var account = _ref2.account,
              response = _ref2.response;
          return /*#__PURE__*/React.createElement(MenuItem, {
            primaryText: account.platform,
            onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;

                      if (!confirm("This will permanently delete this post from your ".concat(account.platform, ". Are you sure you wish to delete this?"))) {
                        _context.next = 4;
                        break;
                      }

                      _context.next = 4;
                      return deleteLivePost(organization.id, post.id, function () {
                        var sap = post.SocialAccountPosts.find(function (s) {
                          return s.SocialAccount.platformId === account.platform_id;
                        });
                        return sap ? sap.SocialAccountId : null;
                      }());

                    case 4:
                      _context.next = 9;
                      break;

                    case 6:
                      _context.prev = 6;
                      _context.t0 = _context["catch"](0);
                      console.error(_context.t0);

                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 6]]);
            }))
          });
        })
      })) : null, /*#__PURE__*/React.createElement(FlatButton, {
        onClick: function onClick() {
          handleReuse(post);
        },
        label: "Reuse Post",
        style: {
          marginLeft: 24
        }
      })];
    } else {
      //future scheduled post
      actions = [/*#__PURE__*/React.createElement(FlatButton, {
        disabled: deletingPost,
        label: deletingPost ? /*#__PURE__*/React.createElement("i", {
          style: {
            fontSize: 20
          },
          className: "fa fa-spinner fa-spin"
        }) : post.QueueId ? 'Replace Queued Post' : 'Delete Post',
        style: {
          marginLeft: 24
        },
        onClick: function onClick() {
          return handleDelete(post);
        }
      }), /*#__PURE__*/React.createElement(FlatButton, {
        disabled: deletingPost,
        label: "Edit Post",
        style: {
          marginLeft: 24
        },
        onClick: function onClick() {
          return handleEdit(post);
        }
      })];
    }

    return actions;
  };

  var pastPost = (_event$post2 = event.post) !== null && _event$post2 !== void 0 && _event$post2.publishAt ? moment(event.post.publishAt).isBefore(moment()) : false;
  return /*#__PURE__*/React.createElement(Wrap, null, /*#__PURE__*/React.createElement(PostWrap, null, /*#__PURE__*/React.createElement(Date, null, event.post.publishRange ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, moment(event.post.publishRange.start).format('ddd, M/D/YY'), /*#__PURE__*/React.createElement("br", null), moment(event.post.publishRange.start).format('h:mm a')), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'Oswald',
      margin: '8px 0'
    }
  }, "TO"), /*#__PURE__*/React.createElement("div", null, moment(event.post.publishRange.end).format('ddd, M/D/YY'), /*#__PURE__*/React.createElement("br", null), moment(event.post.publishRange.start).format('h:mm a'))) : moment(event.post.publishAt).format('ddd, M/D/YY')), /*#__PURE__*/React.createElement(Time, null, event.post.publishRange ? 'Multi-day' : moment(event.post.publishAt).format('h:mm a')), /*#__PURE__*/React.createElement("div", {
    style: {
      borderLeft: '1px solid #dddddd',
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(PostListContent, {
    style: {
      padding: 12
    },
    videoUrl: videoUrl,
    image: image,
    message: message,
    belowMessageContent: belowMessageContent
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: 12
    }
  }, /*#__PURE__*/React.createElement(FilterTypeWrap, null, /*#__PURE__*/React.createElement(FilterTypeCircle, {
    bgColor: bgColor
  }), filterName), event.post.type !== 'AD' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flex: '0 0 220px',
      marginRight: 36,
      paddingBottom: 12
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 13,
      marginRight: 8
    }
  }, pastPost ? 'Posted' : 'Posting', " to:"), /*#__PURE__*/React.createElement(SocialNetworkIconBar, {
    networks: new Set(event.post.platforms.map(function (p) {
      return p.includes('linkedin') ? 'linkedin' : p;
    })),
    iconSize: "medium",
    style: {
      flex: '1 0 auto',
      flexWrap: 'nowrap',
      overflow: 'hidden'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: '1 0 400px',
      paddingBottom: 12
    }
  }, createActionButtons(event.post)))))));
}

export default AgendaEvent;